module.exports = __webpack_public_path__ + "static/media/brussels_mobility.18d5d96f.png";